import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { isMbwayDetails } from './types.js';

const MbwaySummary = ({ details  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            phoneNumber: getLabel('checkout.contact.phoneNumber'),
            hintTitle: getLabel('checkout.completed.paymentDetails.mbway.hint.title'),
            hintMessage: getLabel('checkout.completed.paymentDetails.mbway.hint.message')
        })
    , [
        getLabel
    ]);
    if (!isMbwayDetails(details)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__label"
    }, labels.phoneNumber), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__value"
    }, details.phoneNumber), /*#__PURE__*/ React.createElement(Alert, {
        className: "checkout-payment-info__alert",
        title: labels.hintTitle,
        message: labels.hintMessage
    }));
};

export { MbwaySummary };
//# sourceMappingURL=MbwaySummary.js.map
